import React from 'react';
import SubPage from '../SubPage';
import MEDIA from './mediaData';
import useSite from '../../useSite';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: '소식 자료', en: 'News' };
const T = {
  title: { ko: '홍보 자료', en: 'Media' },
  lede:  { ko: '메디로지스TV 유튜브 채널의 영상으로 ML-CARE 솔루션을 만나보세요.',
           en: 'Meet ML-CARE through videos on the MEDILOGIS TV YouTube channel.' },
  h2:    { ko: '영상으로 보는 메디로지스', en: 'MEDILOGIS in Video' },
  p:     { ko: '제품 소개부터 실제 사용 후기, 센서 부착 방법까지 메디로지스TV 채널에서 영상으로 확인하실 수 있습니다. 썸네일을 누르면 유튜브로 이동합니다.',
           en: 'From product introductions to real user reviews and how to attach the sensor. Click a thumbnail to open it on YouTube.' },
  watch: { ko: '메디로지스TV에서 보기', en: 'Watch on MEDILOGIS TV' },
};

const Play = () => (
  <span className="play" aria-hidden="true">
    <svg fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
  </span>
);

function Media() {
  const { lang } = useLang();
  const rows = useSite('/api/site/media', null);
  const groups = rows
    ? rows.map((g) => ({
        title: (lang === 'en' && g.name_en) ? g.name_en : g.name,
        lede:  (lang === 'en' && g.lede_en) ? g.lede_en : g.lede,
        items: g.items.map((v) => ({
          id: v.id, url: v.url,
          title: (lang === 'en' && v.title_en) ? v.title_en : v.title,
        })),
      }))
    : MEDIA.map((g) => ({
        title: g.title[lang], lede: g.lede[lang],
        items: g.items.map((v) => ({ id: v.id, url: v.url, title: v.title[lang] })),
      }));
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-label">MEDILOGIS TV</div>
      <h2>{T.h2[lang]}</h2>
      <div className="sp-prose"><p>{T.p[lang]}</p></div>

      {groups.map((g, gi) => (
        <div key={gi}>
          <h3 className="sp-group-h">{g.title}</h3>
          {g.lede && <p className="sp-group-lede">{g.lede}</p>}
          <div className="sp-g3">
            {g.items.map((v) => (
              <a className="sp-media" key={v.id} href={v.url} target="_blank" rel="noopener noreferrer">
                <div className="sp-thumb">
                  {/* 썸네일은 유튜브에서 직접 받는다 — 번들에 이미지를 박지 않는다 */}
                  <img src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`} alt="" loading="lazy" />
                  <Play />
                </div>
                <div className="sp-media-meta">
                  <h3>{v.title}</h3>
                  <p>{T.watch[lang]}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      ))}
    </SubPage>
  );
}

export default Media;
